import React from "react";
import Navbar from "../../components/Navbar/Navbar";

import graph from "../../assests/images/chart.svg";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-page">
      <Navbar />
      <div className="banner">
        <div></div>
      </div>
      <div className="profile-content">
        <h1>John Doe</h1>
        <h4>johndoe@gmail.com</h4>
        <div className="flex">
          <div>
            <h2>Below are the pages you can edit</h2>
            <h4>Hosanna Voices</h4>
            <h4>MMU</h4>
          </div>
          <br />
          <div>
            <h2>Content Reach</h2>
            <img src={graph} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
